import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { formPersistenceReducer } from '@repo/ui/hooks';

import { subscriptionApi } from '../features/entitlements/api/subscription-api';

import { countryApi } from './api/country-api';
import { marketplaceApi } from './api/marketplace-api';
import { tenantApi } from './api/tenant-api';

const formPersistConfig = {
  key: 'formPersistence',
  storage,
  whitelist: ['forms'],
};

const rootReducer = combineReducers({
  // Form persistence for country configs
  formPersistence: persistReducer(formPersistConfig, formPersistenceReducer),
  // Subscription API for plan tier and available countries
  [subscriptionApi.reducerPath]: subscriptionApi.reducer,
  // New base API for MODE 1 country configs
  [tenantApi.reducerPath]: tenantApi.reducer,
  // Country API for country configs and document types
  [countryApi.reducerPath]: countryApi.reducer,
  // Marketplace API for service providers
  [marketplaceApi.reducerPath]: marketplaceApi.reducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    })
      .concat(subscriptionApi.middleware)
      .concat(tenantApi.middleware)
      .concat(countryApi.middleware)
      .concat(marketplaceApi.middleware),
});

setupListeners(store.dispatch);

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
